import {
  CheckIcon,
  LockIcon,
  ClipboardIcon,
  FlashIcon,
  TaskIcon,
} from '../../assets/icons/jira-icons';
import vulnerabilityIcon from '../../assets/icons/vulnerabilityIcon.png';
import { Tooltip } from '@mui/material';

const iconMap = {
  bug: LockIcon,
  task: CheckIcon,
  story: ClipboardIcon,
  epic: FlashIcon,
  custom: TaskIcon,
};

export const IssueTypeIcon = ({
  issueType = 'custom',
  size = 16,
  color,
  icon,
  showTooltip = true,
  ...props
}) => {
  const type = issueType?.toLowerCase() || 'custom';
  const tooltipTitle = issueType || 'Custom';
  let content;
  if (type === 'vulnerability') {
    content = (
      <img
        src={vulnerabilityIcon}
        alt={type}
        width={size}
        height={size}
        {...props}
      />
    );
  } else if (icon) {
    content = (
      <img
        src={icon}
        alt={type}
        width={size}
        height={size}
        {...props}
      />
    );
  } else {
    const IconComponent = iconMap[type] || TaskIcon;

    content = (
      <IconComponent
        size={size}
        color={color || getDefaultColor(type)}
        {...props}
      />
    );
  }

  if (!showTooltip) return content;

  return (
    <Tooltip title={tooltipTitle} arrow>
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          lineHeight: 0,
        }}
      >
        {content}
      </span>
    </Tooltip>
  );
};

const getDefaultColor = (type) => {
  switch (type) {
    case 'bug':
      return '#F15B50';
    case 'task':
      return '#4688EC';
    case 'story':
      return '#6A9A23';
    case 'epic':
      return '#BF63F3';
    case 'custom':
      return '#FFAB00';
    default:
      return '#7A869A';
  }
};